import React from "react";

const ActionBlueButton = ({ text, setInvokeModal, disabled }) => {
  return (
    <button
      className={`px-4 py-[6px] gap-2 rounded bg-[#00394d] text-sm font-semibold text-white ${
        disabled ? "bg-[#aaaaaa] text-white  cursor-default" : ""
      }`}
      onClick={() => setInvokeModal(true)}
      disabled={disabled}
    >
      {text}
    </button>
  );
};

export default ActionBlueButton;
